import { render, staticRenderFns } from "./ChangedBoxContainer.vue?vue&type=template&id=627ee8e0&scoped=true&"
import script from "./ChangedBoxContainer.vue?vue&type=script&lang=js&"
export * from "./ChangedBoxContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChangedBoxContainer.vue?vue&type=style&index=0&id=627ee8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ee8e0",
  null
  
)

export default component.exports